import { Component, ElementRef, ViewChild } from '@angular/core';
// import { SplashScreen } from '@capacitor/splash-screen';

// import {Platform} from '@ionic/angular';
// import { SplashScreen } from '@awesome-cordova-plugins/splash-screen/ngx';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  routerHidden = true;
  @ViewChild('splash', { static: false }) splash: ElementRef;
  constructor() {
    // this.load_splash();
    //this.initializeApp();
  }

  ngAfterContentInit() {
    setTimeout(() => {
      this.routerHidden = false;
      //this.splash.nativeElement.style.display="none";
    }, 5000);
  }

  // async load_splash(){
  //   // await SplashScreen.show({
  //   //   showDuration: 5000,
  //   //   autoHide: true,
  //   // });
  // }

  // initializeApp(){
  //   this.platform.ready().then(() => {

  //     this.splashScreen.hide()

  //   })
  // }
}
